import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { getManagementAppAllBranchAsync } from './ManagementStore/managementStoreSlice';
import { toast } from 'react-toastify';
import { MANAGEMENT_APP_COLUMN } from './column';

const DiscountScreen = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [name, setName] = useState('');

  const { allBranchData } = useSelector(({ approvalManagementReducer }) => {
    return {
      allBranchData: approvalManagementReducer.allBranch
        ? approvalManagementReducer.allBranch
        : null,
    };
  });

  useEffect(() => {
    dispatch(getManagementAppAllBranchAsync({ page: 1, limit: 8 }));
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getManagementAppAllBranchAsync({
          params: { page: val, limit: 10 },
        })
      )
        .unwrap()
        .then(() => {
          toast.success('All Schools were fetched successfully!');
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleSearchUser = () => {
    dispatch(
      getManagementAppAllBranchAsync(
        name.match(/^\d/)
          ? {
              params: {
                schoolId: name,
              },
            }
          : {
              params: {
                name: name,
              },
            }
      )
    )
      .unwrap()
      .then((res) => {
        // toast.success('All Offer Details fetched successfully.');
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  return (
    <Box pl={2}>
      <Box mb={2} fontSize={22} fontWeight={'fontWeightMedium'}>
        Branch Info
      </Box>
      <Box mb={2} maxWidth={400}>
        <BuzzInput
          size="small"
          placeholder="Search by school name or schoolId"
          search
          value={name}
          onChange={(e) => setName(e.target.value)}
          onSubmitEditing={handleSearchUser}
        />
      </Box>
      <Box>
        <BuzzTable
          columns={MANAGEMENT_APP_COLUMN}
          data={allBranchData && allBranchData.data}
        />
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={allBranchData && allBranchData.count}
            pageNo={page}
            defaultPage={1}
            perPage={10}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DiscountScreen;
